<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-toolbar class="md-success">
          <div class="md-toolbar-row">
            <div class="md-toolbar-section-start">
              <devices-menu @on-selected="onSelectedDevice"></devices-menu>
              <test-menu @on-selected="onSelectedTestProfile" ref="testMenu"></test-menu>
            </div>
          </div>
        </md-toolbar>
        <br />
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <slide-y-up-transition :duration="200">
          <md-empty-state
            v-show="!test.running && !testResults.length"
            md-icon="playlist_add_check"
            :md-label="$lang.titles.start_testing_process"
            :md-description="$lang.messages.before_start_testing"
          >
            <md-button class="md-primary md-raised" @click="beginTest()">{{$lang.keys.start_test}}</md-button>
          </md-empty-state>
        </slide-y-up-transition>
      </div>

      <div class="md-layout-item md-size-100" v-for="(test, idx) in testResults" :key="idx">
        <slide-y-up-transition :duration="300">
          <md-card>
            <md-card-header class="md-card-header-icon md-card-header-green">
              <div class="card-icon">
                <md-icon>assignment</md-icon>
              </div>
              <h4 class="title">{{$lang.titles.test_case_result}} {{test.ID + 1}}</h4>
            </md-card-header>
            <md-card-content>
              <test-case-table :tableData="test.results"></test-case-table>
            </md-card-content>
          </md-card>
        </slide-y-up-transition>
      </div>

      <div class="md-layout-item md-size-100 mx-auto">
        <div class="text-center spinner" v-show="test.running">
          <md-progress-spinner :md-diameter="100" :md-stroke="6" md-mode="indeterminate"></md-progress-spinner>
          <div class="header text-center">
            <h3 class="title">{{$lang.titles.testing_in_progress}}</h3>

            <h6 style="margin-top: 0px;">{{$lang.titles.test_case}} {{test.current}} / {{test.total}}</h6>
          </div>
        </div>
      </div>

      <div class="md-layout-item md-size-100">
        <slide-y-up-transition :duration="200">
          <md-empty-state
            v-show="!test.running && testResults.length"
            md-icon="playlist_add_check"
            :md-label="$lang.titles.start_another_testing_process"
            :md-description="$lang.messages.before_start_another_testing"
          >
            <md-button class="md-primary md-raised" @click="beginTest(true)">{{$lang.keys.start_test}}</md-button>
          </md-empty-state>
        </slide-y-up-transition>
      </div>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import DevicesMenu from "./components/DevicesMenu";
import TestCaseTable from "./components/TestCaseTable";
import TestMenu from "./components/TestProfilesMenu";
import axios from "axios";
import snackBar from "@/components/SnackBar";
import { getSelectedDeviceToken, getUserToken } from "@/storage/memoryStorage";
import { SlideYUpTransition } from "vue2-transitions";

export default {
  components: {
    TestMenu,
    DevicesMenu,
    "snack-bar": snackBar,
    TestCaseTable,
    SlideYUpTransition
  },
  data() {
    return {
      selectedDevice: {},
      selectedTestProfile: [],
      testResults: [],
      test: {
        running: false,
        current: 0,
        total: 0
      }
    };
  },
  computed: {
    WSmessage() {
      return this.$store.getters.getPayload;
    }
  },
  watch: {
    WSmessage: function(payload, oldPayload) {

      if (payload.topic === "AccuTest/State") {
        if (payload.data.code === 0) {
          this.test = {
            running: false,
            current: 0,
            total: 0
          };
        } else if (payload.data.code === 1) {
          this.test = {
            running: true,
            current: payload.data.test.current,
            total: payload.data.test.total
          };
        }
      } else if (payload.topic === "AccuTest/Data") {
        this.testResults.push(payload.data);
      }
    }
  },

  created() {
    this.$store.commit("setLoading", true);
  },

  methods: {
    onSelectedDevice(device) {
      this.selectedDevice = device;
      this.$store.commit("setLoading", false);
    },

    beginTest(newTest = false) {
      if (newTest){
        this.testResults = [];
      }

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_W + "/applications/accutest/testing",
        data: {
          device_token: this.selectedDevice.token,
          user_token: getUserToken(),
          testProfile: this.selectedTestProfile
        },
        withCredentials: true
      })
        .then(response => {
          this.test.running = true;
        })
        .catch(error => {
          this.test.running = false;

          if (error.response) {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
    },

    onSelectedTestProfile(testProfile) {
      this.selectedTestProfile = testProfile.testCases.map(el => {
        return {
          generator: el.generatorData,
          testConditions: this.getFormattedTestConditions(
            el.testConditions,
            el.accuracy
          )
        };
      });
    },

    getFormattedTestConditions(data, accuracy) {
      let testConditions = [];

      data.forEach(testCondition => {
        switch (testCondition.charAt(0)) {
          case "V":
            testConditions.push({
              testCase: testCondition,
              accuracy: accuracy.U
            });
            break;
          case "I":
            testConditions.push({
              testCase: testCondition,
              accuracy: accuracy.I
            });
            break;
          case "P":
            testConditions.push({
              testCase: testCondition,
              accuracy: accuracy.P
            });
            break;
          case "Q":
            testConditions.push({
              testCase: testCondition,
              accuracy: accuracy.Q
            });
            break;
          case "S":
            testConditions.push({
              testCase: testCondition,
              accuracy: accuracy.S
            });
            break;
        }
      });

      return testConditions;
    }
  }
};
</script>

<style scoped>
.spinner {
  padding-top: 36px;
  padding-bottom: 36px;
}
</style>